module.exports = __webpack_public_path__ + "static/media/v2-explora-people.07b0cbee.jpg";